import { Vue, Component } from 'vue-property-decorator'
import Validator from './validator'

@Component
export default class Form extends Vue {
  readonly validator = new Validator()

  isValidationNotify = false
}
